<div>
  <app-card subtitle="{{ 'content.subscriber' | translate }}:" title="{{ 'content.subscriber-settings' | translate }}">
    <p>{{ companyName }}</p>
  </app-card>
  <app-card subtitle="{{ 'content.administrator-names' | translate }}:" title="{{ 'content.on-site-support' | translate }}">
    @for (admin of adminNames; track admin) {
      <p>{{ admin }}</p>
    }
  </app-card>
</div>
